<template>
  <svg viewBox="0 0 54 56" fill="currentColor">
    <path
      d="M42.3056 50.2545H39.7773L25.8521 4.92857C25.6829 4.37143 25.235 4 24.7273 4H19.2727C18.765 4 18.3171 4.37143 18.1479 4.92857L4.22269 50.2545H1.69444C1.0375 50.2545 0.5 50.8812 0.5 51.6473V54.6071C0.5 55.3732 1.0375 56 1.69444 56H13.6389C14.2958 56 14.8333 55.3732 14.8333 54.6071V51.6473C14.8333 50.8812 14.2958 50.2545 13.6389 50.2545H10.603L14.0769 38.6937H29.8634L33.3373 50.2545H30.3611C29.7042 50.2545 29.1667 50.8812 29.1667 51.6473V54.6071C29.1667 55.3732 29.7042 56 30.3611 56H42.3056C42.9625 56 43.5 55.3732 43.5 54.6071V51.6473C43.5 50.8812 42.9625 50.2545 42.3056 50.2545ZM15.6495 32.7973L21.144 14.7482C21.7113 12.6125 22 10.767 22 10.767C22 10.767 22.219 12.6125 22.856 14.7482L28.2907 32.7973H15.6495Z"
    />
    <path
      d="M42.2246 18V0H46.7754V18H42.2246ZM35.5 11.2754V6.72458H53.5V11.2754H35.5Z"
    />
  </svg>
</template>
